const mutations = {
  onGetAllItems (state, payload) {
    const data = payload.response.data.data
    const context = payload.event.context
    payload.event.context.monitoring = data.data
    context.optionsTable.page = data.current_page
    context.optionsTable.itemsPerPage = parseInt(data.per_page)
    context.optionsTable.total = parseInt(payload.response.data.data.total)
    context.loadMonitoring = false
  },
  onGetGraphic (state, payload) {
    payload.event.context.loadGraphic = false
    payload.event.context.series = payload.response.data.data.series
  },
  onGetPDFByID (state, payload) {
    const inspectionId = payload.event.inspection;
    payload.event.context.$set(payload.event.context.loadReport, inspectionId, false);
    if(!payload.response.data) return
    const incidents = payload.event.context.incidents.find(inc => inc.id === inspectionId)
    const nameFile = incidents ? `#${incidents.consecutive_number} ${incidents.name} ${incidents.created_at}` : payload.event.context.$t('general.inspection')
    payload.event.context.forceFileDownload(payload.response.data, `${nameFile}.pdf`)
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loadGraphic = false
    payload.event.context.loadMonitoring = false
    payload.event.context.loadReport = false

  }
}

export default mutations